<template>
	<v-container fluid class="pa-0">
		<div v-if="isLoaded">
			<v-row class="body-2 font-weight-bold ml-12 my-4">
				<span class="ml-4">{{'team' | localize }}: {{ user.name }}</span>
				<span class="ml-4">{{'current round' | localize }}: {{ game?.round }}</span>
			</v-row>
			<v-divider></v-divider>

			<v-tabs v-model="tab" height="35"
				background-color="primary"
				fixed-tabs
				slider-color="accent"
				dark>
				<v-tab :to="link(item)" ripple
					class="text-capitalize font-weight-bold"
					v-for="item in items"
					:key="item">
					{{ `${item}` | localize}}
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab" continuous>
				<v-tab-item value="/team/reports/sales">
					<sales></sales>
				</v-tab-item>
				<v-tab-item value="/team/reports/channelsSales">
					<channels-sales />
				</v-tab-item>
				<v-tab-item value="/team/reports/segmentSales">
					<segment-results></segment-results>
				</v-tab-item>
				<v-tab-item value="/team/reports/brandAwareness">
					<awareness></awareness>
				</v-tab-item>
				<v-tab-item value="/team/reports/loyalty">
					<loyalty></loyalty>
				</v-tab-item>
				<v-tab-item value="/team/reports/functionalExpansion">
					<functional-expansion />
				</v-tab-item>
				<v-tab-item value="/team/reports/segmentsInsights">
					<segment-insights />
				</v-tab-item>
			</v-tabs-items>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row>
	</v-container>
</template>
<script>
	import Sales from './reports/Sales.vue'
	import ChannelsSales from './reports/ChannelsSales.vue'
	import SegmentResults from './reports/SegmentResults.vue'
	import Awareness from './reports/BrandAwareness.vue'
	import Loyalty from './reports/BrandLoyalty.vue'
	import FunctionalExpansion from './reports/FunctionalExpansion.vue'
	import SegmentInsights from './reports/Insights.vue'

	import Loader from '../../layouts/Loader.vue'

	export default {
		data () {
			return {
				tab: 0,
				items: ['Sales','Channels sales','Segment sales','Brand awareness', 'Loyalty', 'Functional expansion', 'Segments insights'],
				valid: false,
				error: '',
				selected: null,
				numberRules: [v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'],
				isLoaded: false,
			}
		},
		computed: {
			user () {
				return this.$store.getters.user;
			},
			game () {
				return this.$store.getters.game;
			},
			team() {
				return this.$store.getters.team;
			},
			sales() {
				return this.$store.getters.sales_team;
			},
		},
		methods: {
			link(item) {
				const item_arr = item.split(' ')
				const first = item_arr[0].toLowerCase()
				let second = '';

				if (item_arr[1]) {
					second = item_arr[1][0].toUpperCase() + item_arr[1].substr(1)
				}
				//console.log(`/team/market/${first + second}`)				
				return `/team/reports/${first + second}`
			}
		},
		async created() {
			if (!this.game && this.user) {
				//get gameId from the user email
				let game_id = this.user.email.match(/\d/g); 
				if (typeof game_id == 'object'){
					let id = ''
					
					for( let i=0; i < game_id.length; i++) {
						id = game_id[i] + id;
					}
					game_id = parseInt(id)
				}
				try {
					await this.$store.dispatch('fetchGame', game_id);
				} catch (error) {
					await this.$store.dispatch('setError', error.message);
				}
			}

			if (!this.team) {
				const name = `${this.user.name}_${this.game.id}`;
				const team = this.game.teams.find(te => te.name == name)
			
				try {
					await this.$store.dispatch('fetchTeam', team.id);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}
			
			this.isLoaded = true;
		},
		components: {
			Sales,
			ChannelsSales,
			SegmentResults,
			Awareness,
			Loyalty,
			FunctionalExpansion,
			SegmentInsights,
			Loader
		}
	}
</script>